// extracted by css-extract-rspack-plugin
export default {"shadow":"aBa5F"};